import { CustomerRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * customerOnSaveData - Function that saves on database an new customer  
 * /customers  
 * method POST  
 * @async-function
 */
const customerOnSaveData = async (token: string, model: CustomerRequestType) => {
    const response = await api.post(
        `/customers`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default customerOnSaveData;